<template>
  <div class="video-course-item clickable">
    <div class="card-title video-course-item__title typography--body-1"
         :title="course.title">
      {{ `${course.title} (${course.id})`  }}
    </div>

    <div class="typography--body-2">
      <small class="text-muted typography--caption typography--color-secondary">
        {{ getGradeLabel(course) }}
        {{ getSubjectLabel(course) }}
      </small>

      <small class="text-muted typography--caption typography--color-secondary" v-if="course.domain">
        <span class="ml-1 mr-1">|</span>
        {{ `영역: ${course.domain.name}` }}
      </small>
    </div>

    <div class="typography--body-2">
      <small class="text-muted typography--caption typography--color-secondary">
        {{ getUnitName(course) }}
      </small>
    </div>

    <div class="typography--body-2">
      <small class="text-muted typography--caption typography--color-secondary">
        {{ $t('video_lectures.video_course.lecture_count', { count: course.lecture_count }) }}
      </small>

      <small class="text-muted typography--caption typography--color-secondary">
        <span class="ml-1 mr-1">|</span>
        <span v-if="course.share_level === '1'">
          {{ $t('common.card.share_level.public') }}
        </span>
        <span v-else>
          {{ $t('common.card.share_level.private') }}
        </span>
      </small>
    </div>
  </div>
</template>

<script>
  import { filter, map, intersection, isEmpty, join } from 'lodash';
  import { mapGetters } from 'vuex';
  import labels from '@/mixins/labels';

  export default {
    name: 'video-course-item',

    props: {
      course: {
        type: Object,
        default: null,
      },
    },

    mixins: [
      labels,
    ],

    computed: {
      ...mapGetters([
        'subjectMap',
        'gradeMap',
        'unitsWithCoreConcepts',
        'coreConceptVideoCourses',
      ]),
    },

    methods: {
      getUnitName(course) {
        const filteredCoreConceptVideoCourses = filter(this.coreConceptVideoCourses, (c => (
          c.video_course_id === course.id
        )));
        if (filteredCoreConceptVideoCourses.length > 0) {
          const coreConceptIds = map(filteredCoreConceptVideoCourses, 'core_concept_id');
          const filteredUnits = filter(this.unitsWithCoreConcepts, ((u) => {
            const unitCoreConceptIds = map(u.core_concepts, 'id');
            return !(isEmpty(intersection(unitCoreConceptIds, coreConceptIds)));
          }));
          if (filteredUnits.length > 0) {
            const unitNames = map(filteredUnits, (u => (`${u.grade_id}학년 ${u.position}단원 ${u.name}`)));
            return `${join(unitNames, ',')}`;
          }
        }
        return 'AI에 연결된 정보가 없습니다';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .video-course-item {
    .video-course-item__title {
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* number of lines to show */
      max-height: 1.5em;    /* fallback */
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/video-courses/components/VideoCourseItem.vue